// abilityHelper.js
import { AbilityBuilder, createMongoAbility } from '@casl/ability'
import { useAuthHelpers } from '@/@vxapp/Auth/useAuthHelpers'
import { applicationConditionsMatcher, recordConditionEnvelope } from './recordConditions'

export function getAbilities(permissions = []) {
  const { can, cannot, rules } = new AbilityBuilder(createMongoAbility)

  // Always allow guests to read the Auth pages
  can('read', 'Auth:Login')

  const explicitPermissions = useAuthHelpers().sanitizePermissions(permissions) ?? []

  explicitPermissions

    // Only enabled permissions
    .filter(p => p.enabled)
    .sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0))
    .forEach(p => {
      const { action, subject, conditions, fields, inverted } = p

      if (Array.isArray(conditions) && conditions.length > 0)
        throw new TypeError('Permission conditions must be an object')

      const recordMetadata = Object.hasOwn(p, 'recordConditions')

      const ruleConditions = recordMetadata
        ? p.recordConditions !== null
          ? recordConditionEnvelope(p.recordConditions, p.conditionFields)
          : undefined
        : Array.isArray(conditions)
          ? undefined
          : conditions || undefined

      const register = inverted ? cannot : can
      const ruleFields = Array.isArray(fields) && fields.length === 0 ? undefined : fields

      if (ruleFields) register(action, subject, ruleFields, ruleConditions)
      else register(action, subject, ruleConditions)
    })

  return rules
}

export const createApplicationAbility = permissions =>
  createMongoAbility(getAbilities(permissions), { conditionsMatcher: applicationConditionsMatcher })
